import React, { useState } from "react";

const Accordion = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleIndex = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const items = [
    { title: "Section 1", content: "Content for section 1." },
    { title: "Section 2", content: "Content for section 2." },
    { title: "Section 3", content: "Content for section 3." },
    { title: "Section 4", content: "Content for section 4." },
    { title: "Section 5", content: "Content for section 5." },
    { title: "Section 6", content: "Content for section 6." },
    { title: "Section 7", content: "Content for section 7." },
  ];

  return (
    <div className="accordion-wrapper">
      {items.map((item, index) => (
        <div className="accordion" key={index}>
          <div
            className="accordion-btn-wrapper"
            onClick={() => toggleIndex(index)}
          >
            <div className="accordion-title">{item.title}</div>
            <button className="accordion-arrow" />
          </div>
          <div className="accordion-divider" />
          {activeIndex === index && (
            <div className="accordion-content">{item.content}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;
